import { InputText } from "primereact/inputtext";
import { useTranslation } from "react-i18next";
import { useAppDispatch, useAppSelector } from "../../hooks/storeHooks";
import { selectAnswer, selectSelectedInspection } from "../../store/selectors/answerSelectors";
import { setGlobalFilterValue } from "../../store/slices/answerSlice";
import { ChangeEvent } from "react";

export const AnswerTableHeader = () => {
    const { t } = useTranslation("locale");
    const dispatch = useAppDispatch();
    const { globalFilterValue, filteredAnswers, data } = useAppSelector(selectAnswer);
    const selectedInspection = useAppSelector(selectSelectedInspection);

    const onGlobalFilterChange = (e: ChangeEvent<HTMLInputElement>) => {
        dispatch(setGlobalFilterValue(e.target.value));
    };

    return (
        <div className="flex justify-content-between align-items-center">
            <div className="flex align-items-center gap-3">
                <h3 className="m-0">
                    {t("answers.header.answersFor")} {selectedInspection?.vesselName || selectedInspection?.id}
                </h3>
                <span className="text-500">
                    ({filteredAnswers.length} {t("answers.header.ofAnswers")} {data.length} {t("answers.header.answers")})
                </span>
            </div>
            <span className="p-input-icon-left">
                <i className="pi pi-search" />
                <InputText
                    value={globalFilterValue}
                    onChange={onGlobalFilterChange}
                    placeholder={t("answers.table.searchAnswers")}
                />
            </span>
        </div>
    );
};
